import { WindTurbineSVG } from "./WindTurbineSVG";
export default WindTurbineSVG;
